import { Link } from 'react-router-dom';
import {
  LOGISTICS_ORDER_STATUS_LABELS,
  LOGISTICS_ORDER_TYPE_LABELS,
} from '@/modules/logistics/types';
import { RESERVATION_STATUS_LABELS } from '@/modules/reservations/types';
import type { CalendarEvent } from '@/modules/calendar/types';
import { calendarEventClassName } from '@/modules/calendar/utils/statusStyles';
import { modulePaths } from '@/routes/paths';

type CalendarEventChipProps = {
  event: CalendarEvent;
  compact?: boolean;
};

function eventLink(event: CalendarEvent): string {
  if (event.source === 'logistics' && event.logisticsOrderId) {
    return `${modulePaths.logistics}/${event.logisticsOrderId}`;
  }
  if (event.reservationId) {
    return `${modulePaths.reservations}/${event.reservationId}`;
  }
  return modulePaths.calendar;
}

function eventTitleAttr(event: CalendarEvent): string {
  if (event.source === 'logistics') {
    const type = event.logisticsType
      ? LOGISTICS_ORDER_TYPE_LABELS[event.logisticsType]
      : 'Logística';
    const status = event.logisticsStatus
      ? LOGISTICS_ORDER_STATUS_LABELS[event.logisticsStatus]
      : '';
    return `${type} · ${status}`;
  }
  const status = event.reservationStatus
    ? RESERVATION_STATUS_LABELS[event.reservationStatus]
    : '';
  return `${event.title} · ${status}`;
}

export function CalendarEventChip({ event, compact = false }: CalendarEventChipProps) {
  const prefix =
    event.source === 'logistics' ? '🚚 ' : '';
  return (
    <Link
      to={eventLink(event)}
      className={`${calendarEventClassName(event)}${compact ? ' calendar-event--compact' : ''}`}
      title={eventTitleAttr(event)}
    >
      <span className="calendar-event__title">
        {prefix}
        {event.title}
      </span>
      {!compact && event.clientName ? (
        <span className="calendar-event__meta">{event.clientName}</span>
      ) : null}
    </Link>
  );
}
